import { FC, ReactElement, memo } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

const Beamer: FC = (): ReactElement | null => {
  if (window.IS_MOBILE) return null;

  return (
    <div id="beamer" className="beamer">
      <Icon id="beamer-open-btn" name={Icons.Bell} color={theme.colors.gray2} className="pos-relative" size={25} />
    </div>
  );
};

export default memo(Beamer);
